import { Theme } from "@greeter/core";
import { Deserializer } from "./Deserializer";

export class ThemeDeserializer extends Deserializer<Theme> {
  override deserialize(json: any): Theme {
    return { id: json.id, name: json.name, iconUrl: json.iconUrl };
  }
}
